import BlockButtonRounded from "./button.rounded.svg";
import BlockButtonSquare from "./button.square.svg";

export const IconsMap: { [key: string]: any } = {
  "button.rounded": BlockButtonRounded,
  "button.square": BlockButtonSquare,
  "button.-": BlockButtonSquare
};
